import { ApiHelper, IApiResponse } from "../../utils/api-helper";

const url = `${process.env.REACT_APP_API_ENDPOINT}/FiveYearPlans`;

export interface IFiveYearPlanStaffSummarQuery {
    startYear: number;
    orgID?: number;
    PlanRelease?: string;
    planID?: number;
}

class FiveYearPlanService extends ApiHelper {
    constructor(_url: string) {
        super(_url);
    }

    public getFiveYearPlansList(body: any): Promise<IApiResponse | void> {
        try {
            return super.create(body, { name: "list" });
        } catch (e) {
            throw e;
        }
    }

    public getFiveYearPlanSummary(id: number, queries: any): Promise<IApiResponse | void> {
        try {
            return super.getById(id, { name: "summary" }, queries);
        } catch (e) {
            throw e;
        }
    }

    public getFiveYearPlanBody(body: any): Promise<IApiResponse | void> {
        try {
            return super.create(body, { name: "projectlist" });
        } catch (e) {
            throw e;
        }
    }

    public modifyLoanSources(planId: number, ProjectID: number, body: any): Promise<IApiResponse | void> {
        try {
            this.url = `${this.url}/${planId}/Projects`;
            return super.createById(body, ProjectID, { name: "loansources" });
        } catch (e) {
            throw e;
        } finally {
            this.url = url;
        }
    }

    public addProjectToPlan(planId: number, ProjectID: number, queries: any): Promise<IApiResponse | void> {
        try {
            this.url = `${this.url}/${planId}/project`;
            return super.update(undefined, ProjectID, undefined, queries);
        } catch (e) {
            throw e;
        } finally {
            this.url = url;
        }
    }

    public addProjectToPlanList(planId: number, queries: any): Promise<IApiResponse | void> {
        try {
            this.url = `${this.url}/${planId}/project`;
            return super.updatelist(undefined, undefined, queries);
        } catch (e) {
            throw e;
        } finally {
            this.url = url;
        }
    }

    public removeProjectFromPlan(planId: number, ProjectID: number, queries: any): Promise<IApiResponse | void> {
        try {
            this.url = `${this.url}/${planId}/project`;
            return super.delete(ProjectID, queries);
        } catch (e) {
            throw e;
        } finally {
            this.url = url;
        }
    }

    public getFiveYearPlanStaffSummary(queries: any): Promise<IApiResponse | void> {
        try {
            return super.get(queries, { name: "summary" });
        } catch (e) {
            throw e;
        }
    }

    public removeFiveYearPlan(id: number): Promise<IApiResponse | void> {
        try {
            return super.delete(id);
        } catch (e) {
            throw e;
        }
    }
}
const fiveYearPlanAPI = new FiveYearPlanService(url);
export default fiveYearPlanAPI;
